import React, { useState, useEffect, Suspense } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";
import { Box, CssBaseline, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import Sidebar from "./Navbar/Sidebar.jsx";
import Navbar from "./Navbar/Navbar.jsx";
import MainContent from "./Navbar/Main.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoadingFallback = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <CircularProgress />
  </Box>
);

const Layout = () => {
  const theme = useTheme();
  // sm means 600px, md means 900px. If down md (i.e. <900px), start hidden.
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(false);

  useEffect(() => {
    if (isLargeScreen) setDesktopOpen(true);
    else setDesktopOpen(false);
  }, [isLargeScreen]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDesktopToggle = () => {
    setDesktopOpen(!desktopOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Navbar
        handleDrawerToggle={handleDrawerToggle}
        desktopOpen={desktopOpen}
        handleDesktopToggle={handleDesktopToggle}
        mobileOpen={mobileOpen}
      />
      {(!desktopOpen && !mobileOpen) && (
        <Box
          sx={{
            position: "fixed",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            bgcolor: "primary.main",
            color: "white",
            borderTopRightRadius: 30,
            borderBottomRightRadius: 30,
            boxShadow: 4,
            zIndex: 2000,
            transition: "all 0.2s",
            opacity: 0.7,
            "&:hover": { opacity: 1, width: 48 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 40,
            height: 60,
            cursor: "pointer"
          }}
          onClick={() => { isLargeScreen ? handleDesktopToggle() : handleDrawerToggle(); }}
        >
          <ChevronRight fontSize="large" />
        </Box>
      )}
      <Sidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        desktopOpen={desktopOpen}
      />
      <MainContent desktopOpen={desktopOpen}>
        <Suspense fallback={<LoadingFallback />}>
          <Outlet />
        </Suspense>
      </MainContent>
      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default Layout;
